var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 48,
    viewBox: "0 0 96 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.2695 4.31458C76.3536 9.73821 78.8034 16.447 78.8034 23.7303C78.8034 31.0156 76.3534 37.7263 72.2695 43.146C81.3206 38.9275 89.3492 32.5653 95.4609 24.4521L95.9999 23.7305L95.4609 23.009C89.3492 14.8958 81.3167 8.53545 72.2695 4.31507V4.31458Z",
    fill: "#8665CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.538953 23.009L0 23.7305L0.538953 24.4521C6.65065 32.5653 14.6792 38.9276 23.7303 43.146C19.6462 37.7263 17.1945 31.0195 17.1945 23.7303C17.1945 16.4431 19.6445 9.73431 23.7284 4.31458C14.6831 8.53506 6.64869 14.8953 0.538953 23.0086V23.009Z",
    fill: "#8665CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2473 23.7303C58.2473 29.0926 53.6601 33.4382 48.0001 33.4382C42.3418 33.4382 37.7529 29.0924 37.7529 23.7303C37.7529 18.3698 42.3419 14.0225 48.0001 14.0225C53.6603 14.0225 58.2473 18.3699 58.2473 23.7303Z",
    fill: "#009EE1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0001 0C34.6206 0 23.7305 10.6481 23.7305 23.7303C23.7305 36.8126 34.6206 47.4607 48.0001 47.4607C61.3797 47.4607 72.2698 36.8126 72.2698 23.7303C72.2698 10.6481 61.3797 0 48.0001 0ZM48.0001 40.6816C38.4407 40.6816 30.6637 33.0773 30.6637 23.7303C30.6637 14.3833 38.4407 6.77911 48.0001 6.77911C57.5596 6.77911 65.3366 14.3833 65.3366 23.7303C65.3366 33.0773 57.5596 40.6816 48.0001 40.6816Z",
    fill: "#3134DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.41596f592d3d0e2e1487d32b5e0c3229.svg";
export { ForwardRef as ReactComponent };